import { render, staticRenderFns } from "./MobileDataCards.vue?vue&type=template&id=20a011e2"
import script from "./MobileDataCards.vue?vue&type=script&lang=js"
export * from "./MobileDataCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports